import { useState } from 'preact/hooks';

interface Option {
    value: string | number;
    label: string;
}

interface Props {
    options: Option[];
    value: string | number;
    onChange: (value: string) => void;
    placeholder?: string;
    className?: string;
}

export default function LazySelect({ options, value, onChange, placeholder = '—', className = '' }: Props) {
    const [active, setActive] = useState(false);

    const selected = options.find(o => String(o.value) === String(value) || Number(o.value) === Number(value));

    return (
        <select
            className={className}
            value={value ?? ''}
            onMouseDown={() => { if (!active) setActive(true); }}
            onBlur={() => setActive(false)}
            onChange={e => {
                onChange((e.target as HTMLSelectElement).value);
                setActive(false);
            }}
        >
            {active ? (
                <>
                    <option value="">{placeholder}</option>
                    {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                </>
            ) : (
                <option value={value ?? ''}>{selected?.label || placeholder}</option>
            )}
        </select>
    );
}
